export const enum Locale {
  EN = 'en-US',
  DE = 'de-DE',
}

export const languageConfig = {
  languages: [Locale.EN, Locale.DE],
  defaultLanguage: Locale.DE,
  autoDetectLanguage: true,
};
